// Packages.jsx - Updated Version
import { useState, useEffect } from 'react';
import { useAdmin } from '../components/context/AdminContext';
import CustomPackageForm from './CustomPackageForm';

function Packages() {
  const [showForm, setShowForm] = useState(false);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' }); // Object হিসেবে state

  const { getPackages } = useAdmin();

  // Load packages from your custom backend
  useEffect(() => {
    const loadPackages = async () => {
      try {
        const packagesData = await getPackages();
        setPackages(packagesData);
      } catch (error) {
        console.error('Error loading packages:', error);
        setMessage({
          text: 'Error loading packages. Please try again.',
          type: 'error'
        });
      } finally {
        setLoading(false);
      }
    };

    loadPackages();
  }, [getPackages]);

  // Message auto-hide effect
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: '', type: '' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (loading) {
    return (
      <div className="container-xxl py-5">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading packages...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Message Alert - UPDATED to handle object message */}
      {message.text && (
        <div className="container-xxl mt-3">
          <div
            className={`alert ${message.type === 'error' || message.text.includes('Failed')
              ? 'alert-danger'
              : 'alert-success'
              } alert-dismissible fade show mb-0`}
            role="alert"
          >
            <div className="container">
              <i className={`fas ${message.type === 'error' || message.text.includes('Failed')
                ? 'fa-exclamation-triangle'
                : 'fa-check-circle'
                } me-2`}></i>
              {message.text}
              <button
                type="button"
                className="btn-close"
                onClick={() => setMessage({ text: '', type: '' })}
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Travel Packages
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    Packages
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Pre-made Packages Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Pre-made Packages
            </h6>
            <h1 className="mb-5">Awesome Travel Packages</h1>
            <p className="mb-5">Choose from our carefully curated travel packages or create your own custom trip</p>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Dynamic Packages from Backend */}
            {packages.map((pkg, index) => (
              <div
                key={pkg._id}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + (index * 0.2)}s`}
              >
                <div className="package-item shadow-sm h-100">
                  <div className="overflow-hidden position-relative">
                    <img
                      className="img-fluid w-100"
                      src={pkg.image || '/assets/img/package-1.jpg'}
                      alt={pkg.name}
                      style={{ height: '250px', objectFit: 'cover' }}
                    />
                    {pkg.rating && (
                      <div className="position-absolute top-0 end-0 m-3">
                        <span className="badge bg-warning text-dark">
                          <i className="fa fa-star me-1"></i>
                          {pkg.rating}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="d-flex border-bottom">
                    <small className="flex-fill text-center border-end py-2">
                      <i className="fa fa-map-marker-alt text-primary me-2" />
                      {pkg.location}
                    </small>
                    <small className="flex-fill text-center border-end py-2">
                      <i className="fa fa-calendar-alt text-primary me-2" />
                      {pkg.duration}
                    </small>
                    <small className="flex-fill text-center py-2">
                      <i className="fa fa-user text-primary me-2" />
                      {pkg.persons} Person{pkg.persons > 1 ? 's' : ''}
                    </small>
                  </div>
                  <div className="text-center p-4 d-flex flex-column h-100">
                    <div>
                      <h3 className="mb-2 text-primary">${pkg.price}</h3>
                      <h5 className="mb-3">{pkg.name}</h5>
                      <div className="mb-3">
                        {[...Array(5)].map((_, i) => (
                          <small
                            key={i}
                            className={`fa fa-star ${i < (pkg.rating || 5) ? 'text-warning' : 'text-secondary'}`}
                          />
                        ))}
                      </div>
                      <p className="mb-4 flex-grow-1">{pkg.description}</p>
                    </div>
                    <div className="d-flex justify-content-center mb-2 mt-auto">
                      <a
                        href="#"
                        className="btn btn-sm btn-primary px-3 border-end"
                        style={{ borderRadius: "30px 0 0 30px" }}
                      >
                        Read More
                      </a>
                      <a
                        href="#"
                        className="btn btn-sm btn-primary px-3"
                        style={{ borderRadius: "0 30px 30px 0" }}
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Custom Package Box */}
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div
                className="package-item custom-package-box h-100"
                style={{
                  cursor: 'pointer',
                  border: '2px dashed #0d6efd',
                  minHeight: '400px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                }}
                onClick={() => setShowForm(true)}
              >
                <div className="text-center p-4">
                  <div className="custom-package-icon mb-3">
                    <i className="fa fa-plus-circle fa-4x text-primary" />
                  </div>
                  <h3 className="text-primary mb-3">Customize Your Trip</h3>
                  <p className="text-muted mb-4">
                    Can't find your perfect package? Let us create a customized trip just for you!
                  </p>
                  <button className="btn btn-outline-primary btn-lg">
                    Create Custom Package
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Package Modal - Pass the updated setMessage function */}
      <CustomPackageForm
        showForm={showForm}
        setShowForm={setShowForm}
        setMessage={setMessage}
      />

      {/* Booking Section */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="booking p-5">
            <div className="row g-5 align-items-center">
              <div className="col-md-6 text-white">
                <h6 className="text-white text-uppercase">Booking</h6>
                <h1 className="text-white mb-4">Online Booking</h1>
                <p className="mb-4">
                  Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit.
                  Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit.
                </p>
                <p className="mb-4">
                  Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit.
                  Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                  sed stet lorem sit clita duo justo magna dolore erat amet
                </p>
                <a className="btn btn-outline-light py-3 px-5 mt-2" href="">
                  Read More
                </a>
              </div>
              <div className="col-md-6">
                <h1 className="text-white mb-4">Book A Tour</h1>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control bg-transparent"
                          id="name"
                          placeholder="Your Name"
                        />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control bg-transparent"
                          id="email"
                          placeholder="Your Email"
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="form-floating date"
                        id="date3"
                        data-target-input="nearest"
                      >
                        <input
                          type="text"
                          className="form-control bg-transparent datetimepicker-input"
                          id="datetime"
                          placeholder="Date & Time"
                          data-target="#date3"
                          data-toggle="datetimepicker"
                        />
                        <label htmlFor="datetime">Date &amp; Time</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <select
                          className="form-select bg-transparent"
                          id="select1"
                        >
                          <option value={1}>Destination 1</option>
                          <option value={2}>Destination 2</option>
                          <option value={3}>Destination 3</option>
                        </select>
                        <label htmlFor="select1">Destination</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control bg-transparent"
                          placeholder="Special Request"
                          id="message"
                          style={{ height: 100 }}
                          defaultValue={""}
                        />
                        <label htmlFor="message">Special Request</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-outline-light w-100 py-3"
                        type="submit"
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Process Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Process
            </h6>
            <h1 className="mb-5">3 Easy Steps</h1>
          </div>
          <div className="row gy-5 gx-4 justify-content-center">
            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-globe fa-3x text-white" />
                </div>
                <h5 className="mt-4">Choose A Destination</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">
                  Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                  diam eos erat ipsum et lorem et sit sed stet lorem sit
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-dollar-sign fa-3x text-white" />
                </div>
                <h5 className="mt-4">Pay Online</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">
                  Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                  diam eos erat ipsum et lorem et sit sed stet lorem sit
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-plane fa-3x text-white" />
                </div>
                <h5 className="mt-4">Fly Today</h5>
                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />
                <p className="mb-0">
                  Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                  diam eos erat ipsum et lorem et sit sed stet lorem sit
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .package-item {
          transition: all 0.3s ease;
          border-radius: 10px;
          overflow: hidden;
          background: white;
        }
        
        .package-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .custom-package-box {
          transition: all 0.3s ease;
        }
        
        .custom-package-box:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(13, 110, 253, 0.2);
          border-color: #0d6efd !important;
        }
        
        .custom-package-icon {
          transition: transform 0.3s ease;
        }
        
        .custom-package-box:hover .custom-package-icon {
          transform: scale(1.1);
        }
      `}</style>
    </div>
  );
}

export default Packages;